import { normalizeRoleSlug } from "../../../public/utils/roleAccess";
import {
  TOS_FROS_CONTROL_SUBMODULE_SLUG,
  TOS_FROS_SUBMODULE_SLUG,
} from "./toAndFroPermissionSlugs";

function permRow(permMap, slug) {
  const row = permMap?.[slug];
  return row && typeof row === "object" ? row : {};
}

function submodulePerm(permMap, slug, type) {
  if (!permMap || !slug) return false;
  const row = permMap[slug];
  if (!row || typeof row !== "object") return false;
  return Boolean(row[type]);
}

/** Office register — User builder `tos-fros` row. */
function toAndFroRegisterStylePerms(row) {
  const canView = Boolean(row.view);
  const canCreate = Boolean(row.create);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  return {
    canView: canView || canCreate,
    canCreate,
    canEdit,
    canDelete,
    canReturn: canEdit,
    canManageMasters: false,
    canDeleteMasters: false,
    canExport: canView || canCreate,
    isAdmin: false,
  };
}

/** Admin control — User builder `tos-fros-control` row. */
function toAndFroControlStylePerms(permMap) {
  const row = permRow(permMap, TOS_FROS_CONTROL_SUBMODULE_SLUG);
  const registerRow = permRow(permMap, TOS_FROS_SUBMODULE_SLUG);
  const canView = Boolean(row.view);
  const canEdit = Boolean(row.edit);
  const canDelete = Boolean(row.delete);
  const canReturn = Boolean(registerRow.edit) || canEdit;
  return {
    canView,
    canCreate: Boolean(registerRow.create),
    canEdit,
    canDelete,
    canReturn,
    canManageMasters: canView && canEdit,
    canDeleteMasters: canDelete,
    canExport: canView,
    isAdmin: canView,
  };
}

/**
 * Permissions for one to-and-fro screen (User builder submodule row).
 * All roles — including admin — follow User builder only.
 */
export function buildToAndFroPermissionsForScreen(
  permMap = {},
  _roleSlug = "",
  screenSlug = "",
) {
  const slug = normalizeRoleSlug(screenSlug);

  if (slug === TOS_FROS_SUBMODULE_SLUG) {
    return toAndFroRegisterStylePerms(permRow(permMap, slug));
  }

  if (slug === TOS_FROS_CONTROL_SUBMODULE_SLUG) {
    return toAndFroControlStylePerms(permMap);
  }

  return buildToAndFroPermissions(permMap);
}

export function buildToAndFroPermissions(permMap = {}) {
  const canControl = submodulePerm(permMap, TOS_FROS_CONTROL_SUBMODULE_SLUG, "view");
  const registerRow = permRow(permMap, TOS_FROS_SUBMODULE_SLUG);
  const controlRow = permRow(permMap, TOS_FROS_CONTROL_SUBMODULE_SLUG);
  const canView =
    Boolean(registerRow.view) ||
    Boolean(registerRow.create) ||
    canControl;
  const canCreate = Boolean(registerRow.create);
  const canEdit = Boolean(registerRow.edit) || Boolean(controlRow.edit);
  const canDelete = Boolean(controlRow.delete);
  const canReturn = Boolean(registerRow.edit) || Boolean(controlRow.edit);

  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
    canReturn,
    canManageMasters: canControl && Boolean(controlRow.edit),
    canDeleteMasters: canControl && Boolean(controlRow.delete),
    canExport: canView,
    isAdmin: canControl,
  };
}
